import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
import { veteranMilitaryStaus, veteranMilitaryBranch } from '../../../../constants';
var MilitaryComponent = /** @class */ (function () {
    function MilitaryComponent(_services, _parent, googleAnalyticsEventsService) {
        this._services = _services;
        this._parent = _parent;
        this.googleAnalyticsEventsService = googleAnalyticsEventsService;
        this.branchdata = [];
        this.formClass = "";
        this.errormsg = new Array();
        this.errdisplay = false;
        this.checkPrev = 0;
        this.isLoader = false;
        this.trackingName = "Military";
    }
    MilitaryComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, elmnt, secBucket, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this._parent.campaignName) {
                            this.trackingName = this._parent.campaignName + " - Military";
                        }
                        _a = this;
                        return [4 /*yield*/, this._services.getList('/branch')];
                    case 1:
                        _a.branchdata = _c.sent();
                        elmnt = document.getElementById("top");
                        elmnt.scrollIntoView();
                        if (!this._parent.model.uuid) return [3 /*break*/, 5];
                        if (!(this._parent.model.secondary_bucket.length == 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._services.getList('/secondarybucketlist/' + this._parent.model.bucket_id)];
                    case 2:
                        secBucket = _c.sent();
                        secBucket.forEach(function (data) {
                            _this._parent.model.secondary_bucket.push({
                                id: data.secBucketId,
                                name: data.secBucketTitle
                            });
                        });
                        this._parent.model.secondary_bucket_ids = this._parent.model.secondary_bucket.map(function (a) { return a.id; }).join(',');
                        _c.label = 3;
                    case 3:
                        _b = this;
                        return [4 /*yield*/, this._services.post('/flow/check/previousdata', this._parent.model)];
                    case 4:
                        _b.checkPrev = _c.sent();
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MilitaryComponent.prototype.clickSubmit = function (valid) {
        this.errormsg = [];
        if (valid) {
            this.militarysubmit();
        }
        else {
            if (this._parent.model.military_branch == "") {
                this.errdisplay = true;
                this.errormsg.push("Please enter branch of service.");
            }
            if (!(this._parent.model.military_status)) {
                this.errdisplay = true;
                this.errormsg.push("Please enter military status.");
            }
            this.formClass = "validate";
        }
    };
    MilitaryComponent.prototype.militarysubmit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var eduGoal, branchOfService, mbindex, serviceStatus, msindex, scholarUpdate, collegesData, profileCollegeCheck, i, matchData, updataData, matchCollege, insertCollege, matchData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._parent.model.uuid) return [3 /*break*/, 16];
                        this.isLoader = true;
                        return [4 /*yield*/, this._services.post('/search/updateinfo', this._parent.model)];
                    case 1:
                        _a.sent();
                        eduGoal = '';
                        if (this._parent.model.education_goal == "5") {
                            eduGoal = "academic_level_undergraduate";
                        }
                        else if (this._parent.model.education_goal == "7" || this._parent.model.education_goal == "17") {
                            eduGoal = "academic_level_post_graduate";
                        }
                        else if (this._parent.model.education_goal == "18") {
                            eduGoal = "academic_level_certificate";
                        }
                        else if (this._parent.model.education_goal == "3" || this._parent.model.education_goal == "18") {
                            eduGoal = "academic_level_trade_vocational";
                        }
                        branchOfService = "";
                        mbindex = veteranMilitaryBranch.findIndex(function (x) { return x.id == _this._parent.model.military_branch; });
                        if (mbindex < 0) {
                            branchOfService = "";
                        }
                        else {
                            branchOfService = veteranMilitaryBranch[mbindex].name;
                        }
                        serviceStatus = "";
                        msindex = veteranMilitaryStaus.findIndex(function (x) { return x.name.toLowerCase() == _this._parent.model.military_status.toLowerCase(); });
                        if (msindex < 0) {
                            serviceStatus = "";
                        }
                        else {
                            serviceStatus = veteranMilitaryStaus[msindex].value;
                        }
                        scholarUpdate = {
                            "uuid": this._parent.model.uuid,
                            "educationGoal": eduGoal,
                            "studyState": this._parent.model.study_state_values,
                            "militaryBranch": branchOfService,
                            "militaryStatus": serviceStatus,
                            "bucketId": this._parent.model.bucket_id,
                            "secondaryBucketId": this._parent.model.secondary_bucket_ids
                        };
                        return [4 /*yield*/, this._services.post('/veteran/scholarshipdata/update', scholarUpdate)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this._services.post('/search/matchdata', this._parent.model)];
                    case 3:
                        collegesData = _a.sent();
                        profileCollegeCheck = "";
                        if (!this._parent.model.passedIn_college_id) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._services.post('/search/collegeprofile/checkcollege', this._parent.model)];
                    case 4:
                        profileCollegeCheck = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!(this.checkPrev != 1)) return [3 /*break*/, 11];
                        this.saveFiltertracking(this._parent.model);
                        this.saveSearchresultTracking(this._parent.model, collegesData);
                        i = 0;
                        _a.label = 6;
                    case 6:
                        if (!(i < collegesData.length)) return [3 /*break*/, 9];
                        matchData = {
                            "studentId": this._parent.model.uuid,
                            "collegeId": collegesData[i]['collegeId'],
                            "matchPercent": collegesData[i]['percentMatch'],
                            "src": "Flow",
                            "contacted": "No",
                            "isPassedInCollege": (collegesData[i]['collegeId'] == this._parent.model.passedIn_college_id) ? 1 : 0
                        };
                        return [4 /*yield*/, this._services.post('/flow/match/saveupdate/collegelist', matchData)];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        i++;
                        return [3 /*break*/, 6];
                    case 9:
                        updataData = {
                            "studentId": this._parent.model.uuid,
                            "collegeId": collegesData.map(function (a) { return a.collegeId; }).join(',')
                        };
                        return [4 /*yield*/, this._services.post('/flow/match/checkdelete/collegelist', updataData)];
                    case 10:
                        _a.sent();
                        return [3 /*break*/, 15];
                    case 11:
                        if (!(this._parent.model.passedIn_college_id && profileCollegeCheck == 'notexist')) return [3 /*break*/, 13];
                        matchCollege = collegesData.find(function (x) { return x.collegeId == _this._parent.model.passedIn_college_id; });
                        insertCollege = {
                            "studentId": this._parent.model.uuid,
                            "collegeId": this._parent.model.passedIn_college_id,
                            "contacted": "No",
                            "src": "Flow",
                            "matchPercent": matchCollege.percentMatch,
                            "isPassedInCollege": 1
                        };
                        return [4 /*yield*/, this._services.post('/search/profile/matchcollege/insert', insertCollege)];
                    case 12:
                        _a.sent();
                        return [3 /*break*/, 15];
                    case 13:
                        if (!(this._parent.model.passedIn_college_id && profileCollegeCheck == 'exist')) return [3 /*break*/, 15];
                        matchData = {
                            "studentId": this._parent.model.uuid,
                            "collegeId": this._parent.model.passedIn_college_id,
                            "isPassedInCollege": 1
                        };
                        return [4 /*yield*/, this._services.post('/search/profile/matchcollege/update', matchData)];
                    case 14:
                        _a.sent();
                        _a.label = 15;
                    case 15:
                        this.isLoader = false;
                        this._parent.index = 6;
                        return [3 /*break*/, 17];
                    case 16:
                        this._parent.index++;
                        _a.label = 17;
                    case 17: return [2 /*return*/];
                }
            });
        });
    };
    MilitaryComponent.prototype.prevAction = function () {
        this._parent.index--;
    };
    MilitaryComponent.prototype.saveFiltertracking = function (trackdata) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var majordata, index, trackData, statedata, index, trackData1, trackData2, trackData3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        majordata = trackdata.secondary_bucket;
                        index = 0;
                        _a.label = 1;
                    case 1:
                        if (!(index < majordata.length)) return [3 /*break*/, 4];
                        trackData = {
                            "primarySource": "program matcher",
                            "secondarySource": "login",
                            "filterType": "secondary bucket",
                            "value": majordata[index]['id']
                        };
                        return [4 /*yield*/, this._services.post('/college/filter/tracking', trackData)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        index++;
                        return [3 /*break*/, 1];
                    case 4:
                        statedata = trackdata.study_state;
                        index = 0;
                        _a.label = 5;
                    case 5:
                        if (!(index < statedata.length)) return [3 /*break*/, 8];
                        trackData1 = {
                            "primarySource": "program matcher",
                            "secondarySource": "login",
                            "filterType": "state",
                            "value": statedata[index]['value']
                        };
                        return [4 /*yield*/, this._services.post('/college/filter/tracking', trackData1)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        index++;
                        return [3 /*break*/, 5];
                    case 8:
                        trackData2 = {
                            "primarySource": "program matcher",
                            "secondarySource": "login",
                            "filterType": "level",
                            "value": trackdata.education_goal
                        };
                        return [4 /*yield*/, this._services.post('/college/filter/tracking', trackData2)];
                    case 9:
                        _a.sent();
                        trackData3 = {
                            "primarySource": "program matcher",
                            "secondarySource": "login",
                            "filterType": "bucket",
                            "value": trackdata.bucket_id
                        };
                        return [4 /*yield*/, this._services.post('/college/filter/tracking', trackData3)];
                    case 10:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MilitaryComponent.prototype.saveSearchresultTracking = function (trackdata, collegeinfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var trackData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        trackData = {
                            "primarySource": "program matcher",
                            "secondarySource": "login",
                            "filters": JSON.stringify(trackdata),
                            "collegeList": collegeinfo.map(function (a) { return a.collegeId; }).join(',')
                        };
                        return [4 /*yield*/, this._services.post('/searchresult/colleges/tracking', trackData)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return MilitaryComponent;
}());
export { MilitaryComponent };



// WEBPACK FOOTER //
// ./src/app/components/pworkflow/military/military.component.ts.pre-build-optimizer.js